import { SearchPost } from "core/types/search.types";
import { researchApi } from "../../../api";
import { Dispatch } from "../../store.types";
import * as actions from "./search.actions";

export const newSearch =
  (payload: SearchPost) => async (dispatch: Dispatch) => {
    dispatch(actions.isSearchLoading({ isSearchLoading: true }));
    try {
      const search = await researchApi.newSearch(payload);
      dispatch(actions.search({ search }));
      return search;
    } catch (err) {
      // Prima qui c'era solo console.error: se la POST veniva rifiutata (es. 400
      // "troppe piattaforme") l'utente non vedeva nulla e restava sulla schermata
      // risultati a fissare "Stiamo iniziando la scansione... 0" all'infinito,
      // perche' senza id la ricerca non parte e il polling nemmeno.
      // Ora l'errore va nello store E viene rilanciato, cosi' handleSubmit puo'
      // evitare di passare alla schermata risultati.
      const response = (err as { response?: { data?: { error?: string } } })
        ?.response;
      const message =
        response?.data?.error || (err as Error)?.message || "unknown_error";
      dispatch(actions.error({ error: String(message) }));
      throw err;
    } finally {
      dispatch(actions.isSearchLoading({ isSearchLoading: false }));
    }
  };

export const getSearches = () => async (dispatch: Dispatch) => {
  dispatch(actions.isSearchLoading({ isSearchLoading: true }));
  try {
    const searchList = await researchApi.getList();
    dispatch(actions.resultList({ resultList: searchList }));
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(actions.isSearchLoading({ isSearchLoading: false }));
  }
};

export const getSearchDetail = (id: string) => async (dispatch: Dispatch) => {
  dispatch(actions.isSearchLoading({ isSearchLoading: true }));
  try {
    const searchDetail = await researchApi.getSearchDetail(id);
    dispatch(actions.resultDetail({ resultDetail: searchDetail }));
  } catch (error) {
    console.log(error);
  } finally {
    dispatch(actions.isSearchLoading({ isSearchLoading: false }));
  }
};

// refetch "silenzioso" del dettaglio (senza spinner) usato dal polling progressivo
export const pollSearchDetail = (id: string) => async (dispatch: Dispatch) => {
  try {
    const searchDetail = await researchApi.getSearchDetail(id);
    dispatch(actions.resultDetail({ resultDetail: searchDetail }));
  } catch (error) {
    console.log(error);
  }
};

export const resetDetail = () => async (dispatch: Dispatch) => {
  dispatch(actions.isSearchLoading({ isSearchLoading: true }));
  try {
    dispatch(actions.resultDetail({ resultDetail: undefined }));
  } catch (error) {
    console.log(
      "ERRORE: Non è stato possibile resettare il dettaglio ricerca."
    );
  } finally {
    dispatch(actions.isSearchLoading({ isSearchLoading: false }));
  }
};

export const getAutoSearchConfig = () => async (dispatch: Dispatch) => {
  dispatch(actions.isAutoLoading({ isAutoLoading: true }));
  try {
    const config = await researchApi.getAutoSearchList();
    dispatch(
      actions.automaticConfigElements({ automaticConfigElements: config })
    );
  } catch (error) {
    console.log(
      "Errore: impossibile recuperare le configurazioni automatiche."
    );
  } finally {
    dispatch(actions.isAutoLoading({ isAutoLoading: false }));
  }
};

export const removeAutoConfigParam =
  (id: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isAutoLoading({ isAutoLoading: true }));
    try {
      await researchApi.deleteParamsAutoSearch(id);
      dispatch(actions.success({ success: "Param deleted successfully" }));
    } catch (error) {
      dispatch(actions.error({ error: "Error deleting param." }));
    } finally {
      dispatch(actions.isAutoLoading({ isAutoLoading: false }));
    }
  };

export const addAutoConfigParam =
  (param: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isAutoLoading({ isAutoLoading: true }));
    try {
      await researchApi.newParamsAutoSearch(param);
      dispatch(actions.success({ success: "Param added successfully." }));
    } catch (error) {
      dispatch(actions.error({ error: "Error adding param." }));
    } finally {
      dispatch(actions.isAutoLoading({ isAutoLoading: false }));
    }
  };

export const editAutoConfigName =
  (id: string, newName: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isAutoLoading({ isAutoLoading: true }));
    try {
      await researchApi.editNameAutoSearch(id, newName);
      dispatch(actions.success({ success: "Name edited successfully." }));
    } catch (error) {
      dispatch(actions.error({ error: "Error editing name." }));
    } finally {
      dispatch(actions.isAutoLoading({ isAutoLoading: false }));
    }
  };

export const addAutoConfigName =
  (name: string) => async (dispatch: Dispatch) => {
    dispatch(actions.isAutoLoading({ isAutoLoading: true }));
    try {
      await researchApi.newNameAutoSearch(name);
      dispatch(actions.success({ success: "Name added successfully." }));
    } catch (error) {
      dispatch(actions.error({ error: "Error adding name." }));
    } finally {
      dispatch(actions.isAutoLoading({ isAutoLoading: false }));
    }
  };

export const addFirstParams =
  (params: string[]) => async (dispatch: Dispatch) => {
    dispatch(actions.isAutoLoading({ isAutoLoading: true }));
    const promises = params.map((param) =>
      researchApi.newParamsAutoSearch(param)
    );
    try {
      const results = await Promise.all(promises);
      if (results) {
        dispatch(actions.success({ success: "Params added successfully." }));
      }
    } catch (error) {
      dispatch(actions.error({ error: "Error adding params." }));
    } finally {
      dispatch(actions.isAutoLoading({ isAutoLoading: false }));
    }
  };
